import { Toaster as Sonner, toast } from 'sonner';
import { useTheme } from '@/app/theme/ThemeProvider';

/**
 * Global toast host (sonner), mounted once in App. Use `toast.success('Saved')`,
 * `toast.error(err.message)` etc. from anywhere.
 */
export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="bottom-right"
      closeButton
      richColors
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
    />
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- re-export so pages import from one place
export { toast };
